import GatewayAxiosClient from '../GatewayAxiosClient';
import { getToken } from '../../session';
import type {
  PCOrigin,
  PCOriginResponse,
  PCTenant,
  PCOriginSchedule,
  PCOriginCreate,
  PCOriginScheduleEntryCreate,
  PCOriginScheduleEntry,
  PCTenantResponse,
} from '../../partnerConfiguration/types';

export class PartnerConfigurationService {
  public async fetchPCOrigins(): Promise<PCOriginResponse> {
    const res = await GatewayAxiosClient.get('/partner-management-proxy/api/v1/partnerConfiguration/origins', {
      headers: {
        authorization: `Bearer ${getToken()}`,
      },
    });
    return res.data;
  }

  public async fetchPCOrigin(originId: string): Promise<PCOrigin> {
    const res = await GatewayAxiosClient.get(
      `/partner-management-proxy/api/v1/partnerConfiguration/origins/${originId}`,
      {
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res.data;
  }

  public async updatePCOrigin(payload: PCOrigin): Promise<PCOrigin> {
    const res = await GatewayAxiosClient.patch(
      `/partner-management-proxy/api/v1/partnerConfiguration/origins/${payload.originId}`,
      payload,
      {
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res.data;
  }

  public async createPCOrigin(payload: PCOriginCreate): Promise<PCOrigin> {
    const res = await GatewayAxiosClient.post(
      '/partner-management-proxy/api/v1/partnerConfiguration/origins',
      payload,
      {
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res.data;
  }

  public async deletePCOrigin(originId: string): Promise<PCOrigin> {
    const res = await GatewayAxiosClient.delete(
      `/partner-management-proxy/api/v1/partnerConfiguration/origins/${originId}`,
      {
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res.data;
  }

  public async fetchPCSchedules(originId: string): Promise<PCOriginSchedule> {
    const res = await GatewayAxiosClient.get(
      `/partner-management-proxy/api/v1/partnerConfiguration/origins/${originId}/schedule`,
      {
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res.data;
  }

  public async createPCSchedule(
    originId: string,
    payload: PCOriginScheduleEntryCreate,
  ): Promise<PCOriginScheduleEntry> {
    const res = await GatewayAxiosClient.post(
      `/partner-management-proxy/api/v1/partnerConfiguration/origins/${originId}/schedule/entry`,
      payload,
      {
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res.data;
  }

  public async deletePCSchedule(originId: string, scheduleId: string): Promise<PCOriginScheduleEntry> {
    const res = await GatewayAxiosClient.delete(
      `/partner-management-proxy/api/v1/partnerConfiguration/origins/${originId}/schedule/entry/${scheduleId}`,
      {
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res.data;
  }

  public async fetchPCTenants(): Promise<PCTenantResponse> {
    const res = await GatewayAxiosClient.get('/partner-management-proxy/api/v1/partnerConfiguration/tenants', {
      headers: {
        authorization: `Bearer ${getToken()}`,
      },
    });
    return res.data;
  }

  public async fetchPCTenant(tenantId: string): Promise<PCTenant> {
    const res = await GatewayAxiosClient.get(
      `/partner-management-proxy/api/v1/partnerConfiguration/tenants/${tenantId}`,
      {
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res.data;
  }

  public async updatePCTenant(payload: PCTenant): Promise<PCTenant> {
    const res = await GatewayAxiosClient.patch(
      `/partner-management-proxy/api/v1/partnerConfiguration/tenants/${payload.tenantId}`,
      payload,
      {
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res.data;
  }

  public async createPCTenant(payload: PCTenant): Promise<PCTenant> {
    const res = await GatewayAxiosClient.post(
      '/partner-management-proxy/api/v1/partnerConfiguration/tenants',
      payload,
      {
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res.data;
  }

  public async deletePCTenant(tenantId: string): Promise<PCTenant> {
    const res = await GatewayAxiosClient.delete(
      `/partner-management-proxy/api/v1/partnerConfiguration/tenants/${tenantId}`,
      {
        headers: {
          authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res.data;
  }
}
